import sha256 from 'crypto-js/sha256';

export default class FeedbackSection {
	static init() {
		const element = document.querySelector('.feedback-section');
		if (!element) {
			return;
		}

        const action = element.dataset.action;
        const nodeIdentifier = element.dataset.nodeIdentifier;
        const method = 'POST';
        const entryIdentifier = `feedback-${sha256(nodeIdentifier + window.location.search)}`
        const csrfTokenEndpoint = element.dataset.csrfTokenEndpoint

        const hasValidFeedbackStorageItem = window.localStorage.getItem(entryIdentifier) && (window.localStorage.getItem(entryIdentifier) > Date.now())

        const feedbackInfoElement = element.querySelector('.feedback-info')
        if (window.getComputedStyle(feedbackInfoElement).display === 'none') {
            feedbackInfoElement?.removeAttribute('style')
            element.querySelector('.feedback-result')?.removeAttribute('style')
        } else {
            element.querySelector('.feedback__not-helpful-buttton')?.classList.remove('active')
            element.querySelector('.feedback-form')?.removeAttribute('style')
        }

        if ( hasValidFeedbackStorageItem ) {
            FeedbackSection.closeFeedbackSection();
            return;
        }

		element.querySelector('.feedback__helpful-buttton').addEventListener('click', async (e) => {
			const button = e.target;
			const el = button.closest('.feedback-section');
			el.classList.add('feedback-section--form-is-hidden');
            const backendErrorWarning = el.querySelector('.form-backend-error')

            const csrfTokenResponse = await fetch(csrfTokenEndpoint, {
                method: 'POST'
            });
            const csrfToken = await csrfTokenResponse.text();

            // Send XHR Request
            const formData = new FormData();
            formData.append('feedback[positive]', true)
            formData.append('node', el.dataset.nodePath)
            formData.append('feedback[text]', '')
            formData.append('__csrfToken', csrfToken)
            const submissionResponse = await fetch(action, {
                method,
                body: formData
            })

            if (submissionResponse.status === 200) {
                const now = new Date()
                window.localStorage.setItem(entryIdentifier, (now.setMonth(now.getMonth() + 1)).valueOf())
                el.classList.remove('feedback-section--form-is-invalid', 'feedback-section--form-has-backend-error');
                FeedbackSection.closeFeedbackSection();
                FeedbackSection.focusFeedbackSection();
            } else if (submissionResponse.status === 429) {
                backendErrorWarning.innerText = 'Sie können nur fünf Feedback-Meldungen pro Stunde einreichen.'
                el.classList.add('feedback-section--form-has-backend-error')
            }
		});

		document.querySelector('.feedback__not-helpful-buttton').addEventListener('click', (e) => {
			const button = e.target;
			const el = button.closest('.feedback-section');
			button.classList.add('active');
			el.classList.remove('feedback-section--form-is-hidden');

			window.scrollTo({
				behavior: 'smooth',
				left: 0,
				top: document.body.scrollHeight
			});

			setTimeout(() => {
				el.querySelector('.feedback-form textarea').focus();
			}, 250);
		});

		document.querySelector('.feedback-section form').addEventListener('submit', FeedbackSection.onSubmit)
	}

	static async onSubmit(e) {
		e.preventDefault();
        const form = e.target;
		const el = e.target.closest('.feedback-section');
		const textarea = el.querySelector('.feedback-form textarea');
        const backendErrorWarning = el.querySelector('.form-backend-error')
        const csrfTokenEndpoint = el.dataset.csrfTokenEndpoint
		if(!textarea.value || textarea.value.length<5) {
			el.classList.add('feedback-section--form-is-invalid');
			return;
		}

        const csrfTokenResponse = await fetch(csrfTokenEndpoint, {
            method: 'POST'
        });
        const csrfToken = await csrfTokenResponse.text();

        // Send XHR Request
        const action = form.getAttribute('action');
        const method = form.getAttribute('method');
        const formData = new FormData(form);
        formData.append('node', el.dataset.nodePath)
        formData.append('__csrfToken', csrfToken)
        const submissionResponse = await fetch(action, {
            method,
            body: formData
        })

        if (submissionResponse.status === 200) {
            const entryIdentifier = `feedback-${sha256(formData.get('node') + window.location.search)}`
            const now = new Date()
            window.localStorage.setItem(entryIdentifier, (now.setMonth(now.getMonth() + 1)).valueOf())
            el.classList.remove('feedback-section--form-is-invalid', 'feedback-section--form-has-backend-error');
            FeedbackSection.closeFeedbackSection();
            FeedbackSection.focusFeedbackSection();
        } else if (submissionResponse.status === 400) {
            backendErrorWarning.innerText = 'Ihre Eingabe war fehlerhaft. Bitte schreiben Sie nur Buchstaben und Zeichen in das Feld.'
            el.classList.add('feedback-section--form-has-backend-error')
        } else if (submissionResponse.status === 429) {
            backendErrorWarning.innerText = 'Sie können nur fünf Feedback-Meldungen pro Stunde einreichen.'
            el.classList.add('feedback-section--form-has-backend-error')
        }
	}

    static closeFeedbackSection() {
        if ($('.feedback-form').is(':visible')) {
            $('.feedback-info').slideUp(400, function () {
                $('.feedback-form').hide();
                $('.feedback__show-form-button').removeClass('active');
                setTimeout(function () {
                    $('.feedback-result').fadeIn(400);
                }, 50)
            });
        } else {
            $('.feedback-info').fadeOut(400);
            $('.feedback-result').fadeIn(400);
        }
    }

    static focusFeedbackSection() {
        if ($(window).width() < 1024) {
            $('html, body').animate({
                scrollTop: $('.feedback-section').offset().top - ($('#header').outerHeight() + 14)
            }, 250);
        }
    }
}
